import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";

const links = [
  { href: "#problem", label: "Problem" },
  { href: "#pillars", label: "Pillars" },
  { href: "#usp", label: "How it works" },
  { href: "#coach", label: "AI Coach" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-white/[0.06] glass-strong" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
               className="px-3 py-2 text-[13px] text-zinc-400 hover:text-white transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href="#waitlist" data-testid="nav-join-waitlist-btn"
             className="hidden sm:inline-flex items-center gap-2 rounded-full px-4 py-2 text-[13px] font-medium text-ink-900 bg-teal-soft hover:bg-teal-mid transition-all shadow-[0_0_24px_-4px_rgba(45,212,191,0.5)]">
            Join Beta
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
          </a>
          <button data-testid="nav-mobile-menu" onClick={() => setOpen(!open)}
                  className="md:hidden inline-flex items-center justify-center h-9 w-9 rounded-md border border-white/10 text-white" aria-label="Toggle menu">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {open ? <><path d="M18 6 6 18"/><path d="m6 6 12 12"/></> : <><path d="M3 6h18"/><path d="M3 12h18"/><path d="M3 18h18"/></>}
            </svg>
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/[0.06] glass-strong">
          <div className="px-6 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="px-2 py-2 text-sm text-zinc-300 hover:text-white"
                 data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g,"-")}`}>{l.label}</a>
            ))}
            <a href="#waitlist" onClick={() => setOpen(false)} data-testid="nav-mobile-join-btn"
               className="mt-2 inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-medium text-ink-900 bg-teal-soft">Join Beta</a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
